import { cx } from '@chakra-ui/utils';
import { useContext } from 'react';
import type {
  PlaceholderProps as ReactSelectPlaceholderProps,
  OptionTypeBase,
} from 'react-select';

import { Box, type BoxProps } from '@frontend/components';

import { SelectContext } from '../SelectContext';
import { useSelectStyles } from '../SelectStylesContext';
import { BASE_CLASS_NAME, SUGGESTION_FIELD_ICON_RESERVE_RIGHT } from '../const';

export type PlaceholderProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = ReactSelectPlaceholderProps<OptionType, IsMulti> & {
  innerProps: BoxProps;
};

export const Placeholder = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  children,
  innerProps,
}: PlaceholderProps<OptionType, IsMulti>) => {
  const { placeholder: placeholderStyles } = useSelectStyles();
  const { hasSuggestions } = useContext(SelectContext);

  return (
    <Box
      {...innerProps}
      className={cx(`${BASE_CLASS_NAME}__placeholder`, innerProps?.className)}
      __css={{
        ...placeholderStyles,
        ...(hasSuggestions
          ? { right: SUGGESTION_FIELD_ICON_RESERVE_RIGHT }
          : null),
      }}
    >
      {children}
    </Box>
  );
};
